export enum UserPolicies
{
  EMAIL  = 'email',
  PHONE  = 'phone'
}
